export enum UnleashFeatureFlag {
  ea_net_pay_estimate = 'ea_net_pay_estimate',
  show_benefit_features = 'show_benefit_features',
  has_approved_benefit_features = 'has_approved_benefit_features',
  ea_ben_ai = 'ea_ben_ai',
  dashboard_revamp_phase_1 = 'dashboard_revamp_phase_1',
  uses_full_text_search = 'uses_full_text_search',
  total_reward_statement = 'total_reward_statement',
  pending_renewal_subscriptions_migrated = 'pending_renewal_subscriptions_migrated',
  reimbursement_request_force_weavr_2fa = 'reimbursement_request_force_weavr_2fa',
  use_payroll_period_price_display = 'use_payroll_period_price_display',
  benefit_allowance_drawer = 'benefit_allowance_drawer',
  language_switcher = 'language_switcher',
  benefit_page_redesign_phase_1 = 'benefit_page_redesign_phase_1',
  can_view_payroll_report_configuration = 'can_view_payroll_report_configuration',
  equity_modeler = 'equity_modeler',
  price_widget_v2 = 'price_widget_v2',
  employer_driven_homepage = 'employer_driven_homepage',
  employer_driven_homepage_builder = 'employer_driven_homepage_builder',
  use_ach_micro_deposit = 'use_ach_micro_deposit',
  can_export_payroll_instruction_report = 'can_export_payroll_instruction_report',
  can_view_payroll_runs = 'can_view_payroll_runs',
  intent_onboarding_enabled = 'intent_onboarding_enabled',
  opella_net_pay_simulator = 'opella_net_pay_simulator',
  ecc_ask_ben = 'ecc_ask_ben',
  new_beneficiary_flow_enabled = 'new_beneficiary_flow_enabled',
}
